export const SIDEBAR_WIDTH = 240;
export const CANT_UNLINK_ALL_DIALOG = 'cant-unlink-all-dialog';
export const UNLINK_CONFIRMATION_DIALOG = 'unlink-confirmation-dialog';
